<ecp-header>
  <ecp-nav class="mobile" *ecpShowAuthed="false" [toRight]="true">
    <ecp-nav-item label="Login" link="#" (click)="openLoginDialog($event)"> </ecp-nav-item>
  </ecp-nav>
  <ng-container *ecpShowAuthed="false">
    @if (showDesktopLoginMessage) {
    <div class="desktop-login-message" role="alert">
      {{ desktopLoginMessage }}
    </div>
    }
  </ng-container>
  <ecp-nav *ecpShowAuthed="true">
    @for (item of menu.app; track item) {
    <ecp-nav-item ecpToggle="is-open" [children]="item.children" [label]="item.label" [link]="item.link">
    </ecp-nav-item>
    }
  </ecp-nav>
</ecp-header>
<ecp-sidenav [appNav]="menu.app" [userNav]="menu.user">
  <main class="page-content">
    <ng-content></ng-content>
  </main>
</ecp-sidenav>
<!--<div class="element shadow-btnfloat" *ecpShowAuthed="true">-->
<!--  <div mat-fab class="chat-wrapper btn btn-secondary btn-block button&#45;&#45;full-width" aria-label="Cisco ECE Chat">-->
<!--    <span *ngIf="!isMinimized" (click)="isMinimized = true" class="minimize">-->
<!--      <mat-icon>minimize</mat-icon>-->
<!--    </span>-->

<!--    <ng-container *ngIf="!isMinimized">-->
<!--      <ng-container *ngTemplateOutlet="chatText"></ng-container>-->
<!--    </ng-container>-->
<!--    <ng-container *ngIf="isMinimized">-->
<!--      <div (click)="goToChat()">-->
<!--        <ng-container *ngTemplateOutlet="chatText"></ng-container>-->
<!--      </div>-->
<!--    </ng-container>-->

<!--    <button *ngIf="!isMinimized" (click)="goToChat()" class="question-btn btn btn-primary btn-block button&#45;&#45;full-width">-->
<!--      Have Questions? - Chat Now-->
<!--    </button>-->
<!--  </div>-->
<!--</div>-->

<!--<ng-template #chatText>-->
<!--  <span class="blinking-text show-desktop hide-mobile">-->
<!--    <mat-icon>question_answer</mat-icon>-->
<!--    Chat ( <span class="dot-{{ chatStatus }}"></span> {{ chatStatus }} )-->
<!--  </span>-->
<!--  <span class="blinking-text show-mobile hide-desktop"-->
<!--    ><mat-icon>question_answer</mat-icon><span class="dot-{{ chatStatus }}"></span-->
<!--  ></span>-->
<!--</ng-template>-->

<ecp-footer></ecp-footer>
